import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const WhiteBoardApp16Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1262 637l623-606 134 138-415 405q-30 30-54 55t-47 48-48 48-58 51l-250 113 115-252zm786-318v1345H0V256h1470l-131 128H128v279q34-21 87-51t113-57 118-47 100-20q49 0 83 27t35 80q0 43-20 85t-43 77q-40 66-63 137t-23 150q0 33 7 77t25 83 47 66 72 28q49 0 98-32t92-77 78-96 56-86l110 66q-22 36-49 76t-59 80-69 75-78 63-85 43-92 16q-75 0-128-36t-87-92-50-124-16-131q0-96 27-184t78-170l2-4q10-17 19-33t17-36q-20 3-54 15t-74 29-82 39-80 44-68 42-44 35v716h1792V444l128-125z" />
    </svg>
  ),
  displayName: 'WhiteBoardApp16Icon',
});

export default WhiteBoardApp16Icon;
